import { PaymentTypes } from '../../types';

const initialState = {
  withdraws: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PaymentTypes.SAVE_THERAPIST_ACCOUNT_INFO:
      return { ...state, ...payload };
    default:
      return state;
  }
};
